import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Modal from 'react-modal';
import Swal from 'sweetalert2';

import { saveReviewer, deleteReviewerById, createNew as createNewReviewer } from '../../../../../../api/reviewer';
import Icon from '../../../../../Common/Icon';
import { Attendee, Reviewer } from '../../../../../../types';

const customStyles = {
  content: {
    width: '30%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
};

const useStyles = makeStyles(() => ({

  input: {
    width: '100%'
  },
  form_button: {
    background: '#26377B',
    color: '#FFFFFF',
    borderRadius: 10,
    padding: 5,
    marginTop: 10,
    marginRight: 10,
    textAlign: 'center',
    width: 100,
    cursor: 'pointer'
  },
  delete_button: {
    background: 'red',
  },
}));

interface EditReviewerProps {
  isModalOpen: boolean;
  closeModal: () => void;
  reviewer: Reviewer;
  attendee: Attendee;
}

const EditAttendee = ({ isModalOpen, closeModal, reviewer, attendee }: EditReviewerProps) => {
  const isValid = (reviewer: any) => {
    if (reviewer === undefined || reviewer.name === undefined || reviewer.name == "") {
      return false;
    }
    if (reviewer.email === undefined || reviewer.email == "" || reviewer.email == attendee.email) {
      return false;
    }
    if (reviewer.escalation_path_emails !== undefined && reviewer.escalation_path_emails !== "") {
      return reviewer.escalation_path_emails.match(/[A-Za-z0-9+.-_]+@[A-Za-z0-9+.-_]+/) !== null
    }
    return true;
  }

  const [updatedReviewer, setUpdatedReviewer] = useState<Reviewer>(reviewer)

  useEffect(() => {
    setUpdatedReviewer(reviewer);

  }, [reviewer])
  const classes = useStyles();

  const save = () => {
    if (!isValid(updatedReviewer)) {
      return;
    }
    const action = updatedReviewer.id === undefined
      ? createNewReviewer
      : saveReviewer

    action(updatedReviewer)
      .then(closeModal) //TODO? also edit the self review entity
  }

  const deleteReviewer = () => {
    Swal.fire({
      title: 'Please confirm!',
      text: 'Are you sure you want to remove this reviewer?',
      icon: 'warning',
      confirmButtonText: 'Confirm',
      showCancelButton: true
    }).then((choice: any) => {
      if (choice.isDismissed) {
        //noop
      } else if (choice.isConfirmed) {
        if (updatedReviewer.id) {
          deleteReviewerById(updatedReviewer.id)
            .then(closeModal)
        } else {
          closeModal();
        }
      }
    })

  }


  return (

    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Manage Reviewer"
    >

      <h2>Reviewer</h2>
      <Grid container
        direction="column"
        justify="center"
      >
        <Grid item xs={9}>
          <TextField
            label="name"
            value={updatedReviewer.name}
            className={classes.input}
            onChange={(e) => {
              e.persist();
              if (updatedReviewer) {
                setUpdatedReviewer({ ...updatedReviewer, name: e.target.value })
              }
            }
            }
          />
        </Grid>

        <Grid item xs={9}>
          <TextField
            label="email"
            value={updatedReviewer.email}
            className={classes.input}
            onChange={(e) => {
              e.persist();
              if (updatedReviewer) {
                setUpdatedReviewer({ ...updatedReviewer, email: e.target.value })
              }
            }
            }
          />
        </Grid>

        <Grid item xs={9}>
          <TextField
            label="points of escalation emails"
            value={updatedReviewer.escalation_path_emails}
            className={classes.input}
            onChange={(e) => {
              e.persist();
              if (updatedReviewer) {
                setUpdatedReviewer({ ...updatedReviewer, escalation_path_emails: e.target.value })
              }
            }
            }
          />
        </Grid>

      </Grid>
      <Grid container
        direction="row"
      // justify="space-between"
      // alignItems="flex-start"
      >

        <div className={`${classes.form_button}`} onClick={save}>
          Save {isValid(updatedReviewer) ? <Icon icon="edit" /> : <Icon icon="exclamation" />}
        </div>
        {updatedReviewer.id && (
          <div className={`${classes.form_button} ${classes.delete_button}`} onClick={deleteReviewer}>
            Delete <Icon icon="trash-alt" />
          </div>
        )}
        <div className={classes.form_button} onClick={() => {
          closeModal();
        }}>
          Cancel
        </div>
      </Grid>

    </Modal>

  )
};

export default EditAttendee;
